import React from 'react'
import SkeletonBlock from '@component/skeleton/SkeletonBlock'

interface IProps {
    className?: string
}

const MobileUserProfileSkeleton = ({className}: IProps) => {
    return (
        <div className={`space-y-[10px] ${className}`}>
            <SkeletonBlock className={'w-[50%] h-[21px]'} sizeClassName={'h-[21px]'} />

            <div className={'flex items-center gap-x-[7px]'}>
                <div className={'w-[50px]'}>
                    <SkeletonBlock className={'w-[50px] h-[50px]'} sizeClassName={'w-[50px] h-[50px] rounded-full'} />
                </div>

                <div className={'w-full space-y-[3px]'}>
                    <SkeletonBlock className={'w-full'} sizeClassName={'h-[15px]'} />
                    <SkeletonBlock className={'w-full h-[21px]'} sizeClassName={'h-[21px]'} />
                </div>
                <div className={'w-full space-y-[3px]'}>
                    <SkeletonBlock className={'w-full'} sizeClassName={'h-[15px]'} />
                    <SkeletonBlock className={'w-full h-[21px]'} sizeClassName={'h-[21px]'} />
                </div>
                <div className={'w-full space-y-[3px]'}>
                    <SkeletonBlock className={'w-full'} sizeClassName={'h-[15px]'} />
                    <SkeletonBlock className={'w-full h-[21px]'} sizeClassName={'h-[21px]'} />
                </div>
                <div className={'w-full space-y-[3px]'}>
                    <SkeletonBlock className={'w-full'} sizeClassName={'h-[15px]'} />
                    <SkeletonBlock className={'w-full h-[21px]'} sizeClassName={'h-[21px]'} />
                </div>
            </div>
        </div>
    )
}
export default MobileUserProfileSkeleton
